function getGenericMeta (vm) {
  const { meta } = vm.$options
  if (meta) {
    return typeof meta === 'function'
      ? meta.call(vm)
      : meta
  }
}
export default {
  created () {
    const meta = getGenericMeta(this)
    if (meta && meta.name && meta.content) {
      if (document.querySelector(`meta[name=${meta.name}]`)) {
        document.querySelector(`meta[name=${meta.name}]`).setAttribute('content', meta.content)
      } else {
        let metaObj = document.createElement('meta')
        metaObj.name = meta.name
        metaObj.content = meta.content
        document.getElementsByTagName('head')[0].appendChild(metaObj)
      }
    }
  }
}
